export default{
    getFileType(file){
        let file_type='';
        file_type=file.type.split('/')[1];
        return file_type;
    }
}


// WEBPACK FOOTER //
// ./src/leo.wang.util/file.operator.js